<template>
    <div>
      <h1>Reset Password</h1>
      <!-- Aggiungi qui il modulo per il reset della password -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResetPassword',
  };
  </script>
  